import React, { useContext } from 'react'
import Image from 'next/image'
import ProfileContext from '@/components/Context/ProfileContext'

const BannerGroupement: React.FC = () => {
  const { profile } = useContext(ProfileContext)

  return profile.groupLesOfficinales ? (
    <div style={{ marginBottom: 16 }}>
      <Image
        src={'/images/groupement/officap/banner-officap.png'}
        width={1200}
        height={90}
        layout={'responsive'}
        alt={'groupement'}
      />
    </div>
  ) : profile.groupCos ? (
    <div style={{ marginBottom: 16 }}>
      <Image
        src={'/images/groupement/cos/banner-cos.png'}
        width={1200}
        height={187}
        layout={'responsive'}
        alt={'groupement'}
      />
    </div>
  ) : profile.groupGcapPharma ? (
    <div style={{ marginBottom: 16 }}>
      <Image
        src={'/images/groupement/gcapPharma/banner-gcapPharma.png'}
        width={1200}
        height={187}
        layout={'responsive'}
        alt={'groupement'}
      />
    </div>
  ) : profile.groupAeliaStore ? (
    <div style={{ marginBottom: 16 }}>
      <Image
        src={'/images/groupement/aelia/banner_aelia.png'}
        width={1200}
        height={187}
        layout={'responsive'}
        alt={'groupement'}
      />
    </div>
  ) : null
}

export default BannerGroupement
